<div class="optimization-container">
    <div class="container">
        @if (bestJobIdInfo$ | async; as bestJobIdInfo) {
            <div class="optimization-header">
                <div class="d-inline-flex mb-3">
                    <h4 class="my-auto d-inline-flex" translate="BEST_SOLUTION"></h4>
                    @if (isRideSharingEnabled) {
                        <h4 id="status-enabled" class="ml-2 my-auto ride-sharing-status d-inline-flex"
                            translate="RIDE_SHARING_ENABLED"
                        >
                        </h4>
                        <app-tooltip
                            appCustomPopover
                            popoverText="{{ isRideSharingInRoute ? 'RIDE_SHARING_SOLUTION_ICON_ENABLED' : 'RIDE_SHARING_SOLUTION_ICON_DISABLED' }}"
                            placement="top"
                            [compact]="true"
                            class="ml-2 my-auto h-100"
                        >
                            <ng-container icon>
                                @if (isRideSharingInRoute) {
                                    <img class="mx-auto my-0 solution-ride-sharing-icon"
                                         id="icon-enabled"
                                         src="assets/images/icons/24_car_ride_sharing_white.svg"
                                         alt="{{'RIDE_SHARING_SOLUTION_ICON_ENABLED' | translate}}">
                                }
                                @if (!isRideSharingInRoute) {
                                    <img class="mx-auto my-0 solution-ride-sharing-icon"
                                         id="icon-disabled"
                                         src="assets/images/icons/24_car_ride_sharing_grey.svg"
                                         alt="{{'RIDE_SHARING_SOLUTION_ICON_DISABLED' | translate}}">
                                }
                            </ng-container>
                        </app-tooltip>
                    }
                </div>
                @if (objectiveWeights$ | async; as objectiveWeights) {
                    <div
                        class="optimization-header-objective-weights"
                    >
                        @if (objectiveWeights.timeWindowWeight) {
                            <span>
                            {{ 'LATE_ARRIVALS' | translate }}: <b>{{ objectiveWeights.timeWindowWeight | translate }} </b>
                            </span>
                        }
                        @if (objectiveWeights.travelTimeWeight) {
                            <span>
                            {{ 'TRAVEL_TIME' | translate }}: <b>{{ objectiveWeights.travelTimeWeight | translate }} </b>
                            </span>
                        }
                        @if (objectiveWeights.visitHistoryWeight) {
                            <span>
                            {{ 'VISIT_CONTINUITY' | translate }}:
                            <b>{{ objectiveWeights.visitHistoryWeight | translate }} </b>
                            </span>
                        }
                        @if (objectiveWeights.overqualifiedWeight) {
                            <span>
                            {{ 'OVERQUALIFICATION' | translate }}:
                            <b>{{ objectiveWeights.overqualifiedWeight | translate }}</b>
                            </span>
                        }
                        @if (objectiveWeights.rosterPriority) {
                            <span>
                            {{ 'ROSTER_PRIORITY' | translate }}:
                            <b>{{ objectiveWeights.rosterPriority | translate }}</b>
                            </span>
                        }
                    </div>
                }
            </div>
            <app-optimization-solution
                [jobIdInfo]="bestJobIdInfo"
                (loading)="solutionLoading($event)"
                (optimizationComplete)="solutionFinished($event)"
                [isRideSharingEnabled]="isRideSharingEnabled"
                (solutionTick)="solutionTick($event)"
            ></app-optimization-solution>
            @if (alternativeJobIdInfos$ | async; as alternativeJobIdInfos) {
                <div class="optimization-header d-flex mb-3">
                    <h4 class="my-auto" translate="ALTERNATIVE_SOLUTIONS"></h4>
                    @if (isRideSharingEnabled) {
                        <h4 id="status-disabled" class="ml-2 my-auto ride-sharing-status"
                            translate="RIDE_SHARING_DISABLED"
                        >
                        </h4>
                    }
                    @if (isRideSharingEnabled !== true) {
                        <app-info-tooltip class="ml-1 my-auto" iconSize="sm"
                                          appCustomPopover
                                          popoverText="ALTERNATIVE_SOLUTIONS_INFO_TEXT"></app-info-tooltip>
                    }
                </div>
                @for (jobIdInfo of alternativeJobIdInfos; track trackByFn($index, jobIdInfo)) {
                    <app-optimization-solution
                        [jobIdInfo]="jobIdInfo"
                        (loading)="solutionLoading($event)"
                        (optimizationComplete)="solutionFinished($event)"
                        [isRideSharingEnabled]="isRideSharingEnabled"
                        [objectiveWeights$]="objectiveWeights$"
                    ></app-optimization-solution>
                }
            }
            <div class="optimization-btns">
                @if (isRideSharingEnabled && !optimizationFinished && (isRouteComparisonEnabled | async)) {
                    <app-info-tooltip
                        iconSize="md"
                        class="my-auto mr-1"
                        appCustomPopover
                        popoverText="COMPARE_TOOLTIP"
                        placement="left">
                    </app-info-tooltip>
                }
                @if (isRideSharingEnabled && (isRouteComparisonEnabled | async)) {
                    <button
                        [disabled]="!optimizationFinished"
                        type="button"
                        class="btn btn-primary my-auto d-flex align-items-center justify-content-center mr-2"
                        (click)="openRouteCompareModal()"
                    >
                        <img class="mr-1" src="/assets/images/icons/16_compare.svg" alt="">
                        <span translate="COMPARE"></span>
                    </button>
                }
                <button
                    type="button"
                    class="btn btn-default mr-2 my-auto"
                    translate="BUTTON_RESTART_OPTIMIZATION"
                    (click)="restartOptimization()"
                ></button>
                @if ((optimizationSettingsPlacementEnabled | async) != true) {
                    <button
                        type="button"
                        class="btn btn-default d-flex align-items-center my-auto justify-content-center"
                        (click)="openSettingsModal()"
                    >
                        <div class="vismaicon icon-settings mr-1"></div>
                        <span translate="BUTTON_SETTINGS"></span>
                    </button>
                }
            </div>
        }
        <app-spinner
            [overlay]="true"
            [overlayRounded]="true"
            [infoText]="solutionsLoadingText"
            [visible]="solutionsLoading"
        ></app-spinner>
    </div>
</div>
<app-spinner infoText="CHECKING_ROUTES_INFO" [visible]="loading"></app-spinner>
